"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var lodash_1 = require("lodash");
var wix_vod_cards_1 = tslib_1.__importDefault(require("@wix/wix-vod-cards"));
var module_1 = tslib_1.__importDefault(require("@wix/wix-vod-annoto/dist/module"));
var hls_1 = tslib_1.__importDefault(require("playable/dist/src/adapters/hls"));
var constants_1 = require("playable/dist/src/constants");
var react_playable_1 = tslib_1.__importDefault(require("react-playable"));
var player_api_facade_1 = tslib_1.__importDefault(require("./player-api-facade"));
var findChangedProps = function (currentProps, previousProps) {
    var uniqKeys = lodash_1.uniq(tslib_1.__spread(Object.keys(currentProps), Object.keys(previousProps)));
    return uniqKeys
        .filter(function (key) { return key !== 'children'; }) // children is handled by React so we can skip it
        .reduce(function (acc, key) {
        var _a;
        if (!lodash_1.isEqual(currentProps[key], previousProps[key])) {
            return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[key] = currentProps[key], _a));
        }
        return acc;
    }, {});
};
var makeConfigurationChanger = function (handlers) { return function (changes) {
    lodash_1.entries(changes).forEach(function (_a) {
        var _b = tslib_1.__read(_a, 2), propName = _b[0], propValue = _b[1];
        if (handlers[propName]) {
            handlers[propName](propValue);
        }
    });
}; };
var VODPlayer = /** @class */ (function (_super) {
    tslib_1.__extends(VODPlayer, _super);
    function VODPlayer() {
        var _this = _super.call(this) || this;
        /**
         * ReactPlayable will do shallow compare of it's props,
         * so we need to persist this array
         */
        _this.convertToPlayableSrc = lodash_1.memoize(function (urls) {
            return lodash_1.map(urls, function (_a) {
                var url = _a.url, type = _a.type;
                return ({
                    url: url,
                    type: type,
                });
            });
        });
        _this.onInit = function (playerInstance) {
            _this.player = playerInstance;
            playerInstance.setRtl(_this.props.isRTL);
        };
        _this.handleVideoViewMode = function (mode) {
            _this.player.setVideoViewMode(mode);
        };
        _this.handleLoop = function (isLoop) {
            _this.player.setLoop(isLoop);
        };
        _this.handleMuted = function (muted) {
            if (muted) {
                _this.player.mute();
            }
            else {
                _this.player.unmute();
            }
        };
        _this.handlePlaysInline = function (isInline) {
            _this.player.setPlaysinline(isInline);
        };
        _this.handlePlayableChanges = function (targetProps) {
            var changes = findChangedProps(_this.props, targetProps);
            if (!lodash_1.isEmpty(changes)) {
                _this.changePlayerUI(changes);
            }
            return changes;
        };
        _this.handlePauseVideoOnFullScreenExit = function (isMobile) {
            if (isMobile) {
                _this.player.enablePauseVideoOnFullScreenExit();
            }
            else {
                _this.player.disablePauseVideoOnFullScreenExit();
            }
        };
        _this.handlePlaybackStateChanged = function (playbackState) {
            var _a;
            var _b = _this.props, onPlay = _b.onPlay, onPause = _b.onPause, onEnded = _b.onEnded;
            var handlers = (_a = {},
                _a[constants_1.EngineState.PLAYING] = onPlay,
                _a[constants_1.EngineState.PAUSED] = onPause,
                _a[constants_1.EngineState.ENDED] = onEnded,
                _a);
            if (handlers[playbackState]) {
                handlers[playbackState]();
            }
        };
        _this.handleLogoProperties = function (logo) {
            if (!logo) {
                _this.player.setLogo();
                return;
            }
            _this.player.setLogo(logo.src);
            _this.player.setAlwaysShowLogo(logo.showAlways);
        };
        _this.handlePlayAtFullScreen = function (playAtFullScreen) {
            if (playAtFullScreen) {
                _this.player.enableEnterFullScreenOnPlay();
            }
            else {
                _this.player.disableEnterFullScreenOnPlay();
            }
        };
        _this.handleSetMainUIShouldAlwaysShow = function (setMainUIShouldAlwaysShow) {
            _this.player.setMainUIShouldAlwaysShow(setMainUIShouldAlwaysShow);
        };
        _this.handleOnTitleClick = function (onTitleClick) {
            return _this.player.setTitleClickCallback(onTitleClick);
        };
        _this.handleCanDownload = function (canDownload) {
            var onDownloadClick = _this.props.onDownloadClick;
            if (onDownloadClick && canDownload) {
                _this.player.setDownloadClickCallback(onDownloadClick);
                _this.player.showDownloadButton();
                return;
            }
            _this.player.setDownloadClickCallback();
            _this.player.hideDownloadButton();
        };
        _this.handleOnWatchOnSiteClick = function (onWatchOnSiteClick) {
            _this.player.setLogoClickCallback(onWatchOnSiteClick);
        };
        _this.handlePlaying = function (_a) {
            var isVideoPlayRequested = _a.isVideoPlayRequested, vidiUrls = _a.vidiUrls, isVideoPauseRequested = _a.isVideoPauseRequested;
            var shouldTriggerPlay = lodash_1.isEmpty(vidiUrls) ? false : isVideoPlayRequested;
            if (shouldTriggerPlay && isVideoPauseRequested) {
                console.warn('VODPlayer: isVideoPlayRequested and isVideoPauseRequested both true');
                return;
            }
            if (shouldTriggerPlay) {
                _this.player.play();
            }
            if (isVideoPauseRequested) {
                _this.player.pause();
            }
        };
        _this.makePlayableConfig = function (_a) {
            var isAnnotoModuleEnabled = _a.isAnnotoModuleEnabled, disableFullScreen = _a.disableFullScreen, hideOverlay = _a.hideOverlay, modules = _a.modules, hideMainUI = _a.hideMainUI;
            return ({
                modules: tslib_1.__assign(tslib_1.__assign({ cards: wix_vod_cards_1.default }, (isAnnotoModuleEnabled && { annoto: module_1.default })), modules),
                disableFullScreen: disableFullScreen,
                playbackAdapters: [hls_1.default],
                hideOverlay: hideOverlay,
                hideMainUI: hideMainUI,
            });
        };
        _this.player = null;
        _this.changePlayerUI = makeConfigurationChanger({
            logo: _this.handleLogoProperties,
            playAtFullScreen: _this.handlePlayAtFullScreen,
            onTitleClick: _this.handleOnTitleClick,
            canDownload: _this.handleCanDownload,
            onWatchOnSiteClick: _this.handleOnWatchOnSiteClick,
            setMainUIShouldAlwaysShow: _this.handleSetMainUIShouldAlwaysShow,
            mobileMode: _this.handlePauseVideoOnFullScreenExit,
            muted: _this.handleMuted,
            playInline: _this.handlePlaysInline,
            loop: _this.handleLoop,
            videoViewMode: _this.handleVideoViewMode,
        });
        _this.convertToPlayableSrc.cache = new Map();
        return _this;
    }
    VODPlayer.prototype.componentDidMount = function () {
        this.changePlayerUI(this.props);
        this.handlePlaying(this.props);
        this.props.onInit(this.player);
    };
    VODPlayer.prototype.componentDidUpdate = function (prevProps) {
        var changes = this.handlePlayableChanges(prevProps);
        if (changes.isVideoPlayRequested || changes.isVideoPauseRequested) {
            this.handlePlaying(this.props);
        }
    };
    VODPlayer.prototype.render = function () {
        var _a = this.props, children = _a.children, onUserSeek = _a.onUserSeek, onSeek = _a.onSeek, onMuteChange = _a.onMuteChange, onVolumeChange = _a.onVolumeChange, vidiUrls = _a.vidiUrls, autoPlay = _a.autoPlay, preload = _a.preload, fillAllSpace = _a.fillAllSpace, videoItem = _a.videoItem, canShowTitle = _a.canShowTitle, texts = _a.texts, width = _a.width, height = _a.height, posterUrl = _a.posterUrl, onPlayAbort = _a.onPlayAbort, onError = _a.onError, onFullScreenChanged = _a.onFullScreenChanged;
        var config = this.makePlayableConfig(this.props);
        var src = this.convertToPlayableSrc(vidiUrls);
        return (react_1.default.createElement(react_playable_1.default, { width: width, height: height, fillAllSpace: fillAllSpace, src: src, autoplay: autoPlay, preload: preload, title: canShowTitle ? videoItem.title : null, poster: posterUrl, texts: texts, config: config, onInit: this.onInit },
            react_1.default.createElement(player_api_facade_1.default, { onFullScreenChanged: onFullScreenChanged, onPlaybackStateChanged: this.handlePlaybackStateChanged, onUserSeek: onUserSeek, onSeek: onSeek, onMute: onMuteChange, onVolumeChange: onVolumeChange, onPlayAbort: onPlayAbort, onError: onError }, children)));
    };
    VODPlayer.propTypes = {
        children: prop_types_1.default.node,
        vidiUrls: prop_types_1.default.array,
        className: prop_types_1.default.string,
        preload: prop_types_1.default.string,
        videoViewMode: prop_types_1.default.string,
        posterUrl: prop_types_1.default.string,
        width: prop_types_1.default.number,
        height: prop_types_1.default.number,
        onInit: prop_types_1.default.func,
        onUserSeek: prop_types_1.default.func,
        onSeek: prop_types_1.default.func,
        onPlay: prop_types_1.default.func,
        onPause: prop_types_1.default.func,
        onEnded: prop_types_1.default.func,
        onPlayAbort: prop_types_1.default.func,
        onFullScreenChanged: prop_types_1.default.func,
        onAnomalyDetected: prop_types_1.default.func,
        onError: prop_types_1.default.func,
        onMuteChange: prop_types_1.default.func,
        onVolumeChange: prop_types_1.default.func,
        onTitleClick: prop_types_1.default.func,
        onDownloadClick: prop_types_1.default.func,
        onWatchOnSiteClick: prop_types_1.default.func,
        setMainUIShouldAlwaysShow: prop_types_1.default.bool,
        muted: prop_types_1.default.bool,
        autoPlay: prop_types_1.default.bool,
        loop: prop_types_1.default.bool,
        canShowTitle: prop_types_1.default.bool,
        canDownload: prop_types_1.default.bool,
        isAnnotoModuleEnabled: prop_types_1.default.bool,
        disableFullScreen: prop_types_1.default.bool,
        hideOverlay: prop_types_1.default.bool,
        hideMainUI: prop_types_1.default.bool,
        isVideoPlayRequested: prop_types_1.default.bool,
        isVideoPauseRequested: prop_types_1.default.bool,
        mobileMode: prop_types_1.default.bool,
        playAtFullScreen: prop_types_1.default.bool,
        playInline: prop_types_1.default.bool,
        loader: prop_types_1.default.bool,
        isRTL: prop_types_1.default.bool,
        texts: prop_types_1.default.object,
        modules: prop_types_1.default.object,
        channelData: prop_types_1.default.object,
        videoItem: prop_types_1.default.object,
    };
    VODPlayer.defaultProps = {
        width: 640,
        height: 360,
        mobileMode: false,
        logo: null,
        preload: 'metadata',
        canShowTitle: true,
        onPause: lodash_1.noop,
        onPlay: lodash_1.noop,
        onEnded: lodash_1.noop,
        onPlayAbort: lodash_1.noop,
        onVideoInfoShow: lodash_1.noop,
        onBuyRentButtonClick: lodash_1.noop,
        onShareVideoShow: lodash_1.noop,
        onFullScreenChanged: lodash_1.noop,
        onWatchOnSiteClick: lodash_1.noop,
        onMuteChange: lodash_1.noop,
        onVolumeChange: lodash_1.noop,
        onSeek: lodash_1.noop,
        onUserSeek: lodash_1.noop,
        onError: lodash_1.noop,
        onInit: lodash_1.noop,
        onAnomalyDetected: lodash_1.noop,
        isAnnotoEnabled: false,
        disableFullScreen: false,
        hideOverlay: true,
    };
    return VODPlayer;
}(react_1.default.Component));
exports.default = VODPlayer;
//# sourceMappingURL=vod-player.js.map